import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=530b9484&scoped=true"
import script from "./Base.vue?vue&type=script&lang=ts"
export * from "./Base.vue?vue&type=script&lang=ts"
import style0 from "./Base.vue?vue&type=style&index=0&id=530b9484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530b9484",
  null
  
)

export default component.exports